export default "__VITE_ASSET__Dvc3cN1u__"